import React from 'react';

export interface Props {
    height: number | 320;
    width: number | 322;
}

export const CodingPersonSVG = (props: Props) => {
    return (
        <svg
            width={props.width}
            height={props.height}
            viewBox="0 0 322 320"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g opacity="0.3">
                <path
                    opacity="0.3"
                    d="M298.338 29.6519V263.344H22.8873V29.6519H298.338V29.6519ZM299.222 28.7686H22.0039V264.267H299.222V28.7686Z"
                    fill="#C4ECFE"
                />
                <g opacity="0.3">
                    <path
                        opacity="0.3"
                        d="M299.222 195.686H22.0039V196.529H299.222V195.686Z"
                        fill="#C4ECFE"
                    />
                </g>
                <g opacity="0.3">
                    <path
                        opacity="0.3"
                        d="M299.222 161.997H22.0039V162.84H299.222V161.997Z"
                        fill="#C4ECFE"
                    />
                </g>
                <g opacity="0.3">
                    <path
                        opacity="0.3"
                        d="M299.222 195.686H22.0039V196.529H299.222V195.686Z"
                        fill="#C4ECFE"
                    />
                </g>
                <g opacity="0.3">
                    <path
                        opacity="0.3"
                        d="M299.222 229.414H22.0039V230.258H299.222V229.414Z"
                        fill="#C4ECFE"
                    />
                </g>
                <g opacity="0.3">
                    <path
                        opacity="0.3"
                        d="M299.222 128.268H22.0039V129.112H299.222V128.268Z"
                        fill="#C4ECFE"
                    />
                </g>
                <g opacity="0.3">
                    <path
                        opacity="0.3"
                        d="M299.222 94.5397H22.0039V95.3829H299.222V94.5397Z"
                        fill="#C4ECFE"
                    />
                </g>
                <g opacity="0.3">
                    <path
                        opacity="0.3"
                        d="M299.222 60.8109H22.0039V61.6541H299.222V60.8109Z"
                        fill="#C4ECFE"
                    />
                </g>
            </g>
            <path
                d="M77.2954 152.601C77.9607 152.601 78.5 152.062 78.5 151.396C78.5 150.731 77.9607 150.192 77.2954 150.192C76.6301 150.192 76.0908 150.731 76.0908 151.396C76.0908 152.062 76.6301 152.601 77.2954 152.601Z"
                fill="#BFD9FF"
            />
            <path
                d="M197.674 247.122C198.34 247.122 198.879 246.583 198.879 245.917C198.879 245.252 198.34 244.713 197.674 244.713C197.009 244.713 196.47 245.252 196.47 245.917C196.47 246.583 197.009 247.122 197.674 247.122Z"
                fill="#BFD9FF"
            />
            <path
                d="M260.434 36.9197C261.099 36.9197 261.639 36.3804 261.639 35.7151C261.639 35.0498 261.099 34.5105 260.434 34.5105C259.769 34.5105 259.229 35.0498 259.229 35.7151C259.229 36.3804 259.769 36.9197 260.434 36.9197Z"
                fill="#BFD9FF"
            />
            <path
                d="M275.451 110.922C276.116 110.922 276.655 110.383 276.655 109.718C276.655 109.052 276.116 108.513 275.451 108.513C274.785 108.513 274.246 109.052 274.246 109.718C274.246 110.383 274.785 110.922 275.451 110.922Z"
                fill="#BFD9FF"
            />
            <path
                d="M41.8394 54.2659C42.5046 54.2659 43.044 53.7266 43.044 53.0613C43.044 52.396 42.5046 51.8567 41.8394 51.8567C41.1741 51.8567 40.6348 52.396 40.6348 53.0613C40.6348 53.7266 41.1741 54.2659 41.8394 54.2659Z"
                fill="#BFD9FF"
            />
            <path
                d="M91.5089 48.283C92.1077 48.283 92.5931 47.7976 92.5931 47.1989C92.5931 46.6001 92.1077 46.1147 91.5089 46.1147C90.9102 46.1147 90.4248 46.6001 90.4248 47.1989C90.4248 47.7976 90.9102 48.283 91.5089 48.283Z"
                fill="#BFD9FF"
            />
            <path
                d="M23.0879 139.15C23.0879 132.444 32.7648 131.44 34.1702 137.985C36.1377 147.301 38.6272 158.102 51.0345 162.318C64.9677 167.056 61.4342 184.643 87.0921 191.67C112.75 198.697 89.7021 254.59 134.112 264.267H23.0879V139.15Z"
                fill="url(#paint0_linear)"
            />
            <path d="M269.709 170.791H51.4766V174.726H269.709V170.791Z" fill="#2B2B2B" />
            <path d="M269.589 174.766H263.767V263.745H269.589V174.766Z" fill="#F9D5FF" />
            <path d="M238.791 174.766H232.969V263.745H238.791V174.766Z" fill="#F9D5FF" />
            <path d="M238.791 173.601H232.969V181.953H238.791V173.601Z" fill="#2B2B2B" />
            <path d="M269.589 173.601H263.767V192.473H269.589V173.601Z" fill="#2B2B2B" />
            <path d="M57.4589 174.766H51.6367V263.745H57.4589V174.766Z" fill="#F9D5FF" />
            <path d="M88.2568 174.766H82.4346V263.745H88.2568V174.766Z" fill="#F9D5FF" />
            <path d="M88.2568 173.601H82.4346V181.953H88.2568V173.601Z" fill="#2B2B2B" />
            <path d="M57.4589 173.601H51.6367V181.953H57.4589V173.601Z" fill="#2B2B2B" />
            <path d="M226.705 78.3578H94.5205V157.5H226.705V78.3578Z" fill="#2B2B2B" />
            <path
                d="M227.87 158.664H93.3564V77.1934H227.87V158.664ZM95.6853 156.335H225.541V79.5222H95.6853V156.335Z"
                fill="#2B2B2B"
            />
            <path d="M163.986 88.2355H103.716V91.1265H163.986V88.2355Z" fill="#5E41F4" />
            <path d="M217.511 88.2355H177.036V91.1265H217.511V88.2355Z" fill="#FFA300" />
            <path d="M134.915 96.5874H103.716V99.4784H134.915V96.5874Z" fill="#FF288C" />
            <path d="M217.51 96.5874H147.965V99.4784H217.51V96.5874Z" fill="#3ACDFF" />
            <path d="M163.986 104.979H103.716V107.87H163.986V104.979Z" fill="#5E41F4" />
            <path d="M217.469 104.979H171.574V107.87H217.469V104.979Z" fill="#FF75C2" />
            <path d="M163.986 113.371H103.716V116.262H163.986V113.371Z" fill="#FFA300" />
            <path d="M217.511 113.371H177.036V116.262H217.511V113.371Z" fill="#FF288C" />
            <path d="M163.986 121.723H103.716V124.614H163.986V121.723Z" fill="#FF288C" />
            <path d="M217.511 121.723H177.036V124.614H217.511V121.723Z" fill="#5E41F4" />
            <path d="M125.84 130.075H103.716V132.966H125.84V130.075Z" fill="#3ACDFF" />
            <path d="M217.47 130.075H138.81V132.966H217.47V130.075Z" fill="#5E41F4" />
            <path d="M149.852 138.467H103.716V141.358H149.852V138.467Z" fill="#5E41F4" />
            <path d="M217.47 138.467H162.861V141.358H217.47V138.467Z" fill="#FFA300" />
            <path d="M163.986 146.859H103.716V149.75H163.986V146.859Z" fill="#3ACDFF" />
            <path d="M217.511 146.859H177.036V149.75H217.511V146.859Z" fill="#FF288C" />
            <path
                d="M164.106 173.802L122.267 172.477C115.481 172.276 109.819 177.576 109.618 184.362C109.578 184.884 116.605 254.51 116.605 254.51L133.71 254.108L134.915 200.986L147.603 206.888L164.106 173.802Z"
                fill="url(#paint1_linear)"
            />
            <path
                d="M111.144 263.585H133.75V254.149L116.645 254.55L110.06 261.015C109.779 261.296 109.618 261.697 109.618 262.099C109.618 262.902 110.301 263.585 111.144 263.585C111.104 263.585 111.104 263.585 111.144 263.585Z"
                fill="#2B2B2B"
            />
            <path
                d="M111.586 163.202C112.469 168.783 117.649 172.597 123.27 171.754C123.511 171.714 123.712 171.674 123.913 171.634L125.077 171.353C130.538 170.148 133.951 164.767 132.786 159.307C131.742 154.569 127.486 151.236 122.628 151.356L121.423 151.396C115.802 151.557 111.304 156.255 111.465 161.876C111.465 162.358 111.545 162.76 111.586 163.202Z"
                fill="#EA7068"
            />
            <path
                d="M216.024 159.789C215.141 165.37 209.961 169.184 204.38 168.341C204.139 168.301 203.938 168.261 203.697 168.221L202.533 167.94C197.112 166.695 193.659 161.274 194.904 155.854C195.988 151.196 200.204 147.863 204.982 147.984L206.187 148.024C211.808 148.184 216.305 152.882 216.145 158.504C216.145 158.945 216.064 159.387 216.024 159.789Z"
                fill="#EA7068"
            />
            <path
                d="M210.925 165.932L209.68 181.833L192.775 180.749L194.944 155.934H201.689C206.829 155.934 211.005 160.07 211.005 165.249C210.925 165.45 210.925 165.691 210.925 165.932Z"
                fill="url(#paint2_linear)"
            />
            <path
                d="M158.204 173.802L200.044 172.477C206.83 172.276 212.491 177.576 212.692 184.362C212.732 184.884 205.705 254.51 205.705 254.51L188.6 254.108L187.396 200.986L170.531 205.724L158.204 173.802Z"
                fill="url(#paint3_linear)"
            />
            <path
                d="M136.843 181.511C132.908 192.273 138.128 207.169 150.334 206.848C159.73 206.607 160.413 206.969 164.348 206.888C176.916 206.567 185.227 193.598 181.332 181.632L136.843 181.511Z"
                fill="url(#paint4_linear)"
            />
            <path
                d="M203.818 169.144L209.64 181.793C212.129 187.213 209.72 193.557 204.34 196.047C204.259 196.087 204.179 196.087 204.099 196.127C199.682 198.014 194.542 196.73 191.531 192.995L174.827 172.276L178.28 138.628L186.191 145.494C193.659 152.039 199.682 160.11 203.818 169.144Z"
                fill="url(#paint5_linear)"
            />
            <path
                d="M115.561 169.144L109.739 181.793C107.249 187.213 109.659 193.557 115.039 196.047C115.12 196.087 115.2 196.087 115.28 196.127C119.697 198.014 124.837 196.73 127.848 192.995L144.552 172.276L141.099 138.628L133.229 145.534C125.72 152.039 119.697 160.11 115.561 169.144Z"
                fill="url(#paint6_linear)"
            />
            <path
                d="M149.093 110.156C149.629 106.851 147.384 103.736 144.079 103.2C140.774 102.663 137.659 104.908 137.123 108.213C136.586 111.519 138.831 114.633 142.136 115.17C145.442 115.706 148.556 113.461 149.093 110.156Z"
                fill="#EA7068"
            />
            <path
                d="M175.068 115.781C178.417 115.781 181.131 113.066 181.131 109.717C181.131 106.369 178.417 103.654 175.068 103.654C171.719 103.654 169.005 106.369 169.005 109.717C169.005 113.066 171.719 115.781 175.068 115.781Z"
                fill="#EA7068"
            />
            <path
                d="M165.833 144.169L176.313 137.504C176.313 137.504 172.057 134.733 164.789 134.813L165.833 144.169Z"
                fill="#2B2B2B"
            />
            <path
                d="M149.892 136.7L150.655 112.207L167.8 111.926L169.205 136.419C169.527 141.519 165.632 145.936 160.532 146.257C160.331 146.257 160.171 146.297 159.97 146.297H159.247C154.108 146.297 149.932 142.161 149.932 136.982C149.892 136.901 149.892 136.821 149.892 136.7Z"
                fill="#EA7068"
            />
            <path
                d="M159.207 129.152C151.699 128.991 145.475 123.209 144.752 115.7L143.588 102.57C143.749 93.6964 151.097 86.5892 160.011 86.7499C168.884 86.9105 175.992 94.2585 175.831 103.173L174.144 116.262C173.181 123.771 166.756 129.312 159.207 129.152Z"
                fill="#FEC73A"
            />
            <path
                d="M181.372 181.632C180.69 179.584 180.328 177.496 180.328 175.368C180.328 171.754 189.001 166.253 188.76 155.332C188.56 146.94 179.445 134.572 164.829 134.853L153.024 135.416C140.175 135.657 130.056 146.94 129.534 155.854H129.494C129.494 156.135 129.534 156.335 129.534 156.617C129.534 156.697 129.534 156.777 129.534 156.857C130.337 171.714 140.737 170.991 136.882 181.552L181.372 181.632Z"
                fill="url(#paint7_linear)"
            />
            <path
                d="M207.15 176.814C206.99 176.814 206.789 176.693 206.749 176.532C202.934 166.374 195.867 156.616 195.787 156.496C195.626 156.295 195.706 156.014 195.867 155.894C196.068 155.733 196.349 155.813 196.469 155.974C196.51 156.054 203.657 165.932 207.552 176.211C207.632 176.452 207.512 176.693 207.271 176.773C207.23 176.814 207.19 176.814 207.15 176.814Z"
                fill="#2B2B2B"
            />
            <path
                d="M181.091 180.548C180.971 180.548 180.81 180.508 180.73 180.387L176.433 175.087C176.273 174.926 176.313 174.605 176.473 174.485C176.634 174.324 176.955 174.364 177.076 174.525L181.372 179.825C181.533 179.986 181.493 180.307 181.332 180.427C181.292 180.508 181.212 180.548 181.091 180.548Z"
                fill="#2B2B2B"
            />
            <path
                d="M136.842 181.953C136.802 181.953 136.802 181.953 136.802 181.953C136.561 181.913 136.401 181.672 136.441 181.471L138.368 168.823C138.408 168.582 138.649 168.422 138.85 168.462C139.091 168.502 139.251 168.743 139.211 168.944L137.284 181.592C137.244 181.793 137.083 181.953 136.842 181.953Z"
                fill="#2B2B2B"
            />
            <path
                d="M211.166 263.585H188.56V254.149L205.625 254.55L212.21 261.015C212.491 261.296 212.651 261.697 212.651 262.099C212.692 262.902 211.969 263.585 211.166 263.585Z"
                fill="#2B2B2B"
            />
            <path
                d="M138.393 232.608L135.363 263.297L141.158 263.869L144.187 233.18L138.393 232.608Z"
                fill="#2B2B2B"
            />
            <path
                d="M182.86 232.586L177.065 233.158L180.096 263.848L185.89 263.276L182.86 232.586Z"
                fill="#2B2B2B"
            />
            <path
                d="M197.232 197.211H197.273C200.806 197.492 203.456 200.624 203.175 204.158L202.894 207.571C202.613 211.104 199.481 213.755 195.947 213.473H195.907C192.374 213.192 189.724 210.06 190.005 206.527L190.286 203.114C190.567 199.54 193.659 196.93 197.232 197.211Z"
                fill="#FD8D45"
            />
            <path
                d="M124.636 213.514H124.595C121.062 213.674 118.01 210.904 117.93 207.33L117.769 203.917C117.609 200.383 120.379 197.332 123.953 197.252H123.993C127.527 197.091 130.578 199.861 130.659 203.435L130.819 206.848C130.98 210.382 128.209 213.353 124.636 213.514Z"
                fill="#FD8D45"
            />
            <path
                d="M181.694 234.433H139.533C132.185 234.433 126.081 228.732 125.559 221.384L123.351 188.9C122.829 181.19 128.651 174.525 136.361 174.003C136.682 173.963 137.003 173.963 137.324 173.963H183.902C191.611 173.963 197.915 180.227 197.915 187.976C197.915 188.297 197.915 188.619 197.875 188.94L195.667 221.424C195.145 228.732 189.042 234.433 181.694 234.433Z"
                fill="#FDCF45"
            />
            <path d="M195.586 262.942H45.4932V264.227H195.586V262.942Z" fill="#2B2B2B" />
            <path
                d="M186.11 264.227C218.032 264.227 216.988 211.707 244.734 204.8C255.816 202.03 261.839 193.156 266.979 183.479C275.532 167.378 298.138 173.882 298.138 192.473V264.267H186.11V264.227Z"
                fill="url(#paint8_linear)"
            />
            <path
                d="M235.499 264.307C252.765 264.307 251.36 241.661 272.079 243.95C279.186 244.753 283.442 235.799 285.691 231.904C289.505 225.479 299.543 228.049 299.543 235.517V264.267H235.499V264.307Z"
                fill="url(#paint9_linear)"
            />
            <path
                d="M187.154 196.087H134.072C133.831 196.087 133.63 195.886 133.63 195.645C133.63 195.404 133.831 195.204 134.072 195.204H187.194C187.435 195.204 187.636 195.404 187.636 195.645C187.636 195.886 187.395 196.087 187.154 196.087Z"
                fill="#FD8D45"
            />
            <path
                d="M184.825 211.787H136.401C136.16 211.787 135.959 211.586 135.959 211.345C135.959 211.104 136.16 210.904 136.401 210.904H184.785C185.026 210.904 185.227 211.104 185.227 211.345C185.227 211.586 185.066 211.787 184.825 211.787Z"
                fill="#FD8D45"
            />
            <path
                d="M35.4766 70.5766L35.7766 71.2766C36.8766 74.0766 39.1766 76.3766 41.9766 77.4766L42.6766 77.7766C43.1766 77.9766 43.3766 78.4766 43.1766 78.9766C43.0766 79.1766 42.8766 79.3766 42.6766 79.4766L41.9766 79.7766C39.1766 80.8766 36.8766 83.1766 35.7766 85.9766L35.4766 86.6766C35.2766 87.1766 34.7766 87.3766 34.2766 87.1766C34.0766 87.0766 33.8766 86.8766 33.7766 86.6766L33.4766 85.9766C32.3766 83.1766 30.0766 80.8766 27.2766 79.7766L26.5766 79.4766C26.0766 79.2766 25.8766 78.7766 26.0766 78.2766C26.1766 78.0766 26.3766 77.8766 26.5766 77.7766L27.2766 77.4766C30.0766 76.3766 32.3766 74.0766 33.4766 71.2766L33.7766 70.5766C33.9766 70.0766 34.4766 69.8766 34.9766 70.0766C35.1766 70.1766 35.3766 70.3766 35.4766 70.5766Z"
                fill="#FDE545"
            />
            <path
                d="M61.5912 0.401065L61.7998 0.887927C62.5649 2.83538 64.1646 4.43508 66.1121 5.20015L66.5989 5.40881C66.9467 5.54791 67.0858 5.89567 66.9467 6.24343C66.8772 6.38253 66.738 6.52164 66.5989 6.59119L66.1121 6.79985C64.1646 7.56492 62.5649 9.16462 61.7998 11.1121L61.5912 11.5989C61.4521 11.9467 61.1043 12.0858 60.7566 11.9467C60.6175 11.8771 60.4784 11.738 60.4088 11.5989L60.2002 11.1121C59.4351 9.16462 57.8354 7.56492 55.8879 6.79985L55.4011 6.59119C55.0533 6.45209 54.9142 6.10433 55.0533 5.75657C55.1229 5.61747 55.262 5.47836 55.4011 5.40881L55.8879 5.20015C57.8354 4.43508 59.4351 2.83538 60.2002 0.887927L60.4088 0.401065C60.5479 0.0533051 60.8957 -0.0857989 61.2434 0.0533051C61.3825 0.122857 61.5216 0.261961 61.5912 0.401065Z"
                fill="#FDE545"
            />
            <path
                d="M245.477 39.5766L245.777 40.2766C246.877 43.0766 249.177 45.3766 251.977 46.4766L252.677 46.7766C253.177 46.9766 253.377 47.4766 253.177 47.9766C253.077 48.1766 252.877 48.3766 252.677 48.4766L251.977 48.7766C249.177 49.8766 246.877 52.1766 245.777 54.9766L245.477 55.6766C245.277 56.1766 244.777 56.3766 244.277 56.1766C244.077 56.0766 243.877 55.8766 243.777 55.6766L243.477 54.9766C242.377 52.1766 240.077 49.8766 237.277 48.7766L236.577 48.4766C236.077 48.2766 235.877 47.7766 236.077 47.2766C236.177 47.0766 236.377 46.8766 236.577 46.7766L237.277 46.4766C240.077 45.3766 242.377 43.0766 243.477 40.2766L243.777 39.5766C243.977 39.0766 244.477 38.8766 244.977 39.0766C245.177 39.1766 245.377 39.3766 245.477 39.5766Z"
                fill="#FDE545"
            />
            <defs>
                <linearGradient
                    id="paint0_linear"
                    x1="78.621"
                    y1="159.067"
                    x2="78.621"
                    y2="243.356"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FFD8A1" />
                    <stop offset="1" stopColor="white" />
                </linearGradient>
                <linearGradient
                    id="paint1_linear"
                    x1="136.861"
                    y1="182.267"
                    x2="136.861"
                    y2="288.158"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#9774AC" />
                    <stop offset="0.4" stopColor="#47A6D3" />
                    <stop offset="0.5" stopColor="#A7A7AE" />
                    <stop offset="0.59" stopColor="#E89AC0" />
                    <stop offset="1" stopColor="#BFE7D1" />
                </linearGradient>
                <linearGradient
                    id="paint2_linear"
                    x1="201.841"
                    y1="199.539"
                    x2="201.841"
                    y2="135.181"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#6B9C83" />
                    <stop offset="0.4" stopColor="#A6A6A4" />
                    <stop offset="0.5" stopColor="#9F9FC8" />
                    <stop offset="0.59" stopColor="#9FCCEC" />
                    <stop offset="1" stopColor="#FFE7B0" />
                </linearGradient>
                <linearGradient
                    id="paint3_linear"
                    x1="185.44"
                    y1="182.267"
                    x2="185.44"
                    y2="288.158"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#9774AC" />
                    <stop offset="0.4" stopColor="#47A6D3" />
                    <stop offset="0.5" stopColor="#A7A7AE" />
                    <stop offset="0.59" stopColor="#E89AC0" />
                    <stop offset="1" stopColor="#BFE7D1" />
                </linearGradient>
                <linearGradient
                    id="paint4_linear"
                    x1="159.05"
                    y1="182.152"
                    x2="156.073"
                    y2="354.418"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#9774AC" />
                    <stop offset="0.4" stopColor="#47A6D3" />
                    <stop offset="0.5" stopColor="#A7A7AE" />
                    <stop offset="0.59" stopColor="#E89AC0" />
                    <stop offset="1" stopColor="#BFE7D1" />
                </linearGradient>
                <linearGradient
                    id="paint5_linear"
                    x1="192.712"
                    y1="185.73"
                    x2="192.712"
                    y2="146.274"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#6B9C83" />
                    <stop offset="0.4" stopColor="#A6A6A4" />
                    <stop offset="0.5" stopColor="#9F9FC8" />
                    <stop offset="0.59" stopColor="#9FCCEC" />
                    <stop offset="1" stopColor="#FFE7B0" />
                </linearGradient>
                <linearGradient
                    id="paint6_linear"
                    x1="126.654"
                    y1="185.73"
                    x2="126.654"
                    y2="146.274"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#6B9C83" />
                    <stop offset="0.4" stopColor="#A6A6A4" />
                    <stop offset="0.5" stopColor="#9F9FC8" />
                    <stop offset="0.59" stopColor="#9FCCEC" />
                    <stop offset="1" stopColor="#FFE7B0" />
                </linearGradient>
                <linearGradient
                    id="paint7_linear"
                    x1="158.59"
                    y1="185.727"
                    x2="159.271"
                    y2="146.278"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#6B9C83" />
                    <stop offset="0.4" stopColor="#A6A6A4" />
                    <stop offset="0.5" stopColor="#9F9FC8" />
                    <stop offset="0.59" stopColor="#9FCCEC" />
                    <stop offset="1" stopColor="#FFE7B0" />
                </linearGradient>
                <linearGradient
                    id="paint8_linear"
                    x1="242.154"
                    y1="190.437"
                    x2="242.154"
                    y2="261.286"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#C0DDFC" />
                    <stop offset="0.19" stopColor="#D3E7FD" />
                    <stop offset="0.49" stopColor="#EBF4FE" />
                    <stop offset="0.77" stopColor="#FAFCFF" />
                    <stop offset="1" stopColor="white" />
                </linearGradient>
                <linearGradient
                    id="paint9_linear"
                    x1="267.548"
                    y1="234.733"
                    x2="267.548"
                    y2="263.116"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FFD8A1" />
                    <stop offset="1" stopColor="white" />
                </linearGradient>
            </defs>
        </svg>
    );
};
